// @ts-nocheck
import React, { useEffect, useState } from 'react';
import api from '../services/api';
import notify from '../utils/toast';
import { useAuth } from '../context/AuthContext';

const API = process.env.REACT_APP_API_URL || '';

export default function Advanced() {
    const { user } = useAuth();
    const [tab, setTab] = useState('pdf');
    const [companies, setCompanies] = useState([]);
    const [audit, setAudit] = useState([]);
    const [supplierPays, setSupplierPays] = useState([]);
    const [suppliers, setSuppliers] = useState([]);
    const [banks, setBanks] = useState([]);
    const [reconList, setReconList] = useState([]);
    const [lines, setLines] = useState([]);
    const [cashFlow, setCashFlow] = useState(null);
    const [gateways, setGateways] = useState([]);
    const [emails, setEmails] = useState([]);
    const [custReturns, setCustReturns] = useState([]);
    const [bookings, setBookings] = useState([]);
    const [crForm, setCrForm] = useState({ booking_id: '', amount: '', return_date: new Date().toISOString().slice(0, 10), return_type: 'partial', refund_method: 'bank', bank_account_id: '', reason: '' });
    const [msg, setMsg] = useState('');

    const [spForm, setSpForm] = useState({
        supplier_id: '', amount: '', payment_date: new Date().toISOString().slice(0, 10), method: 'bank', bank_account_id: '', notes: '',
    });
    const [lineForm, setLineForm] = useState({
        reconciliation_id: '', line_date: new Date().toISOString().slice(0, 10), description: '', debit: '', credit: '',
    });
    const [coForm, setCoForm] = useState({ name: '', code: '', address: '', email: '', phone: '' });
    const [checkout, setCheckout] = useState({ gateway: 'stripe', amount: '', currency: 'BDT', booking_id: '' });
    const token = localStorage.getItem('rems_token');

    const load = () => {
        api.get('/advanced/companies').then((r) => setCompanies(r.data.data)).catch(() => {});
        api.get('/advanced/audit-logs', { params: { limit: 50 } }).then((r) => setAudit(r.data.data)).catch(() => {});
        api.get('/advanced/supplier-payments').then((r) => setSupplierPays(r.data.data)).catch(() => {});
        api.get('/materials/suppliers').then((r) => setSuppliers(r.data.data)).catch(() => {});
        api.get('/system/bank-accounts').then((r) => setBanks(r.data.data)).catch(() => {});
        api.get('/system/reconciliations').then((r) => setReconList(r.data.data)).catch(() => {});
        api.get('/advanced/cash-flow-ias7').then((r) => setCashFlow(r.data.data)).catch(() => {});
        api.get('/advanced/gateway/transactions').then((r) => setGateways(r.data.data)).catch(() => {});
        api.get('/advanced/email/logs').then((r) => setEmails(r.data.data)).catch(() => {});
        api.get('/advanced/customer-returns').then((r) => setCustReturns(r.data.data)).catch(() => {});
        api.get('/bookings').then((r) => setBookings(r.data.data || [])).catch(() => {});
    };

    useEffect(() => { load(); }, []);

    const pdfUrl = (path) => {
        const base = API || '';
        return `${base}/api${path}`;
    };

    const openPdf = async (path) => {
        try {
            const res = await fetch(pdfUrl(path), { headers: { Authorization: `Bearer ${token}` } });
            if (!res.ok) throw new Error('PDF failed');
            const blob = await res.blob();
            window.open(URL.createObjectURL(blob), '_blank');
        } catch (e) {
            alert(e.message);
        }
    };

    const createSupplierPay = async (e) => {
        e.preventDefault();
        try {
            await api.post('/advanced/supplier-payments', {
                ...spForm,
                amount: Number(spForm.amount),
                bank_account_id: spForm.bank_account_id || null,
            });
            setMsg('Supplier payment posted');
            load();
        } catch (err) {
            notify.apiError(err);
        }
    };

    const addLine = async (e) => {
        e.preventDefault();
        try {
            await api.post('/advanced/bank-lines', {
                reconciliation_id: Number(lineForm.reconciliation_id),
                lines: [{
                    line_date: lineForm.line_date,
                    description: lineForm.description,
                    debit: Number(lineForm.debit || 0),
                    credit: Number(lineForm.credit || 0),
                }],
            });
            loadLines(lineForm.reconciliation_id);
            setMsg('Statement line added');
        } catch (err) {
            notify.apiError(err);
        }
    };

    const loadLines = (rid) => {
        api.get('/advanced/bank-lines', { params: { reconciliation_id: rid } })
            .then((r) => setLines(r.data.data))
            .catch(() => setLines([]));
    };

    const matchLine = async (id) => {
        const sug = await api.get(`/advanced/bank-lines/${id}/suggestions`);
        const s = sug.data.data;
        const first = s.payments[0] || s.expenses[0] || s.supplier_payments[0];
        if (!first) {
            await api.post(`/advanced/bank-lines/${id}/match`, { matched_type: 'manual' });
        } else {
            await api.post(`/advanced/bank-lines/${id}/match`, {
                matched_type: first.type,
                matched_id: first.id,
            });
        }
        loadLines(lineForm.reconciliation_id);
    };

    const createCompany = async (e) => {
        e.preventDefault();
        await api.post('/advanced/companies', coForm);
        load();
    };

    const startCheckout = async (e) => {
        e.preventDefault();
        const res = await api.post('/advanced/gateway/checkout', {
            ...checkout,
            amount: Number(checkout.amount),
            booking_id: checkout.booking_id || null,
        });
        setMsg(`Checkout created: ${res.data.data.external_id}`);
        if (res.data.data.checkout_url) window.open(res.data.data.checkout_url, '_blank');
        load();
    };

    const registerPush = async () => {
        // Demo token — replace with real FCM token from service worker
        const demo = `web-demo-${user.id}-${Date.now()}`;
        await api.post('/advanced/push/register', { token: demo, platform: 'web' });
        setMsg('Device token registered (demo). Set FIREBASE_SERVER_KEY for live FCM.');
    };

    const testEmail = async () => {
        const res = await api.post('/advanced/email/test', {
            to: user.email,
            subject: 'SS REM Test',
            message: 'Hello from SS Real Estate Manager v1.3',
        });
        setMsg(res.data.data.simulated ? 'Email simulated (configure SMTP)' : 'Email sent');
        load();
    };

    return (
        <div>
            <h4 className="mb-1">Advanced (v1.3)</h4>
            <p className="text-muted mb-3">PDF · Email · Push · Gateways · Supplier pay · Customer/Supplier returns · Bank lines · IAS 7 · Audit · Company profile</p>
            {msg && <div className="alert alert-info py-2">{msg}</div>}

            <div className="d-flex flex-wrap gap-1 mb-3">
                {['pdf', 'email', 'push', 'supplier', 'returns', 'bank', 'cashflow', 'gateway', 'audit', 'company'].map((t) => (
                    <button key={t} type="button" className={`btn btn-sm text-capitalize ${tab === t ? 'btn-primary' : 'btn-outline-secondary'}`} onClick={() => setTab(t)}>{t}</button>
                ))}
            </div>

            {tab === 'pdf' && (
                <div className="card table-card">
                    <div className="card-body">
                        <p className="small">Enter IDs from Payments / Bookings modules, then open PDF.</p>
                        <div className="row g-2">
                            <div className="col-md-4">
                                <label className="form-label small">Payment ID → Receipt</label>
                                <div className="input-group input-group-sm">
                                    <input id="payId" className="form-control" placeholder="Payment ID" />
                                    <button type="button" className="btn btn-primary" onClick={() => openPdf(`/advanced/pdf/receipt/${document.getElementById('payId').value}`)}>Open</button>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <label className="form-label small">Booking ID → Agreement</label>
                                <div className="input-group input-group-sm">
                                    <input id="bookId" className="form-control" placeholder="Booking ID" />
                                    <button type="button" className="btn btn-primary" onClick={() => openPdf(`/advanced/pdf/agreement/${document.getElementById('bookId').value}`)}>Open</button>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <label className="form-label small">Booking ID → Invoice</label>
                                <div className="input-group input-group-sm">
                                    <input id="invId" className="form-control" placeholder="Booking ID" />
                                    <button type="button" className="btn btn-primary" onClick={() => openPdf(`/advanced/pdf/invoice/${document.getElementById('invId').value}`)}>Open</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {tab === 'email' && (
                <div className="row g-3">
                    <div className="col-md-4">
                        <button className="btn btn-primary btn-sm" onClick={testEmail}>Send test email to me</button>
                        <p className="small text-muted mt-2">Uses SMTP_* env vars, or logs as simulated.</p>
                    </div>
                    <div className="col-md-8">
                        <div className="card table-card">
                            <div className="table-responsive" style={{ maxHeight: 320 }}>
                                <table className="table table-sm mb-0">
                                    <thead><tr><th>To</th><th>Subject</th><th>Status</th></tr></thead>
                                    <tbody>
                                        {emails.map((e) => (
                                            <tr key={e.id}><td>{e.to_email}</td><td>{e.subject}</td><td>{e.status}</td></tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {tab === 'push' && (
                <div className="card table-card">
                    <div className="card-body">
                        <button className="btn btn-primary btn-sm" onClick={registerPush}>Register this browser (demo token)</button>
                        <p className="small text-muted mt-2">Production: obtain FCM token via Firebase SDK / service worker, then POST /advanced/push/register. Set FIREBASE_SERVER_KEY to deliver.</p>
                    </div>
                </div>
            )}

            {tab === 'supplier' && (
                <div className="row g-3">
                    <div className="col-md-5">
                        <div className="card table-card">
                            <div className="card-header fw-semibold">Pay supplier</div>
                            <div className="card-body">
                                <form onSubmit={createSupplierPay} className="row g-2">
                                    <div className="col-12">
                                        <select className="form-select form-select-sm" required value={spForm.supplier_id} onChange={(e) => setSpForm({ ...spForm, supplier_id: e.target.value })}>
                                            <option value="">Supplier</option>
                                            {suppliers.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
                                        </select>
                                    </div>
                                    <div className="col-6"><input type="number" className="form-control form-control-sm" placeholder="Amount" required value={spForm.amount} onChange={(e) => setSpForm({ ...spForm, amount: e.target.value })} /></div>
                                    <div className="col-6"><input type="date" className="form-control form-control-sm" value={spForm.payment_date} onChange={(e) => setSpForm({ ...spForm, payment_date: e.target.value })} /></div>
                                    <div className="col-6">
                                        <select className="form-select form-select-sm" value={spForm.method} onChange={(e) => setSpForm({ ...spForm, method: e.target.value })}>
                                            <option value="bank">Bank</option><option value="cash">Cash</option><option value="cheque">Cheque</option><option value="mobile">Mobile</option>
                                        </select>
                                    </div>
                                    <div className="col-6">
                                        <select className="form-select form-select-sm" value={spForm.bank_account_id} onChange={(e) => setSpForm({ ...spForm, bank_account_id: e.target.value })}>
                                            <option value="">Bank account</option>
                                            {banks.map((b) => <option key={b.id} value={b.id}>{b.name}</option>)}
                                        </select>
                                    </div>
                                    <div className="col-12"><button className="btn btn-primary btn-sm">Post voucher</button></div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-7">
                        <div className="card table-card">
                            <div className="table-responsive">
                                <table className="table table-sm mb-0">
                                    <thead><tr><th>Voucher</th><th>Supplier</th><th>Date</th><th className="text-end">Amount</th></tr></thead>
                                    <tbody>
                                        {supplierPays.map((p) => (
                                            <tr key={p.id}><td>{p.voucher_no}</td><td>{p.supplier?.name}</td><td>{p.payment_date}</td><td className="text-end">{Number(p.amount).toLocaleString()}</td></tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}

      
            {tab === 'returns' && (
                <div className="row g-3">
                    <div className="col-md-5">
                        <div className="card table-card">
                            <div className="card-header fw-semibold">Customer / sales return</div>
                            <div className="card-body">
                                <form onSubmit={async (e) => {
                                    e.preventDefault();
                                    try {
                                        await api.post('/advanced/customer-returns', {
                                            ...crForm,
                                            amount: Number(crForm.amount),
                                            bank_account_id: crForm.bank_account_id || null,
                                        });
                                        setMsg('Customer return posted with journal');
                                        load();
                                    } catch (err) {
                                        notify.apiError(err);
                                    }
                                }} className="row g-2">
                                    <div className="col-12">
                                        <select className="form-select form-select-sm" required value={crForm.booking_id} onChange={(e) => setCrForm({ ...crForm, booking_id: e.target.value })}>
                                            <option value="">Booking</option>
                                            {bookings.map((b) => <option key={b.id} value={b.id}>{b.booking_no} — {b.customer?.name || b.customer_id}</option>)}
                                        </select>
                                    </div>
                                    <div className="col-6"><input type="number" className="form-control form-control-sm" placeholder="Amount" required value={crForm.amount} onChange={(e) => setCrForm({ ...crForm, amount: e.target.value })} /></div>
                                    <div className="col-6"><input type="date" className="form-control form-control-sm" value={crForm.return_date} onChange={(e) => setCrForm({ ...crForm, return_date: e.target.value })} /></div>
                                    <div className="col-6">
                                        <select className="form-select form-select-sm" value={crForm.return_type} onChange={(e) => setCrForm({ ...crForm, return_type: e.target.value })}>
                                            <option value="partial">Partial refund</option>
                                            <option value="full">Full (cancel booking)</option>
                                        </select>
                                    </div>
                                    <div className="col-6">
                                        <select className="form-select form-select-sm" value={crForm.refund_method} onChange={(e) => setCrForm({ ...crForm, refund_method: e.target.value })}>
                                            <option value="bank">Refund bank</option>
                                            <option value="cash">Refund cash</option>
                                            <option value="adjustment">Credit note (AR)</option>
                                            <option value="none">No cash movement</option>
                                        </select>
                                    </div>
                                    <div className="col-12">
                                        <select className="form-select form-select-sm" value={crForm.bank_account_id} onChange={(e) => setCrForm({ ...crForm, bank_account_id: e.target.value })}>
                                            <option value="">Bank account (if refund)</option>
                                            {banks.map((b) => <option key={b.id} value={b.id}>{b.name}</option>)}
                                        </select>
                                    </div>
                                    <div className="col-12"><input className="form-control form-control-sm" placeholder="Reason" value={crForm.reason} onChange={(e) => setCrForm({ ...crForm, reason: e.target.value })} /></div>
                                    <div className="col-12"><button className="btn btn-primary btn-sm">Post return + accounts</button></div>
                                </form>
                                <p className="small text-muted mt-2 mb-0">Journal: Dr Sales Revenue · Cr Bank/Cash/AR. Full return cancels booking and frees unit.</p>
                            </div>
                        </div>
                        <div className="card table-card mt-3">
                            <div className="card-header fw-semibold">Supplier return (stock)</div>
                            <div className="card-body small">
                                Use <strong>Materials → + Transaction → Return to supplier</strong>. Requires supplier + stock.
                                Posts: Dr Accounts Payable · Cr Inventory.
                            </div>
                        </div>
                    </div>
                    <div className="col-md-7">
                        <div className="card table-card">
                            <div className="card-header fw-semibold">Customer returns</div>
                            <div className="table-responsive">
                                <table className="table table-sm mb-0">
                                    <thead><tr><th>Voucher</th><th>Booking</th><th>Customer</th><th>Date</th><th className="text-end">Amount</th><th>Type</th></tr></thead>
                                    <tbody>
                                        {custReturns.map((r) => (
                                            <tr key={r.id}>
                                                <td>{r.voucher_no}</td>
                                                <td>{r.booking?.booking_no}</td>
                                                <td>{r.customer?.name}</td>
                                                <td>{r.return_date}</td>
                                                <td className="text-end">{Number(r.amount).toLocaleString()}</td>
                                                <td>{r.return_type}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {tab === 'bank' && (
                <div className="row g-3">
                    <div className="col-md-5">
                        <div className="card table-card">
                            <div className="card-header fw-semibold">Add statement line</div>
                            <div className="card-body">
                                <form onSubmit={addLine} className="row g-2">
                                    <div className="col-12">
                                        <select className="form-select form-select-sm" required value={lineForm.reconciliation_id} onChange={(e) => { setLineForm({ ...lineForm, reconciliation_id: e.target.value }); loadLines(e.target.value); }}>
                                            <option value="">Reconciliation</option>
                                            {reconList.map((r) => <option key={r.id} value={r.id}>#{r.id} {r.statement_date} ({r.status})</option>)}
                                        </select>
                                    </div>
                                    <div className="col-6"><input type="date" className="form-control form-control-sm" value={lineForm.line_date} onChange={(e) => setLineForm({ ...lineForm, line_date: e.target.value })} /></div>
                                    <div className="col-6"><input className="form-control form-control-sm" placeholder="Description" value={lineForm.description} onChange={(e) => setLineForm({ ...lineForm, description: e.target.value })} /></div>
                                    <div className="col-6"><input type="number" className="form-control form-control-sm" placeholder="Debit" value={lineForm.debit} onChange={(e) => setLineForm({ ...lineForm, debit: e.target.value })} /></div>
                                    <div className="col-6"><input type="number" className="form-control form-control-sm" placeholder="Credit" value={lineForm.credit} onChange={(e) => setLineForm({ ...lineForm, credit: e.target.value })} /></div>
                                    <div className="col-12"><button className="btn btn-primary btn-sm">Add line</button></div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-7">
                        <div className="card table-card">
                            <div className="table-responsive">
                                <table className="table table-sm mb-0">
                                    <thead><tr><th>Date</th><th>Desc</th><th className="text-end">Dr</th><th className="text-end">Cr</th><th>Match</th><th></th></tr></thead>
                                    <tbody>
                                        {lines.map((l) => (
                                            <tr key={l.id}>
                                                <td>{l.line_date}</td><td>{l.description}</td>
                                                <td className="text-end">{l.debit}</td><td className="text-end">{l.credit}</td>
                                                <td>{l.matched ? `${l.matched_type}#${l.matched_id || ''}` : '—'}</td>
                                                <td>{!l.matched && <button type="button" className="btn btn-link btn-sm p-0" onClick={() => matchLine(l.id)}>Match</button>}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {tab === 'cashflow' && cashFlow && (
                <div className="card table-card" style={{ maxWidth: 560 }}>
                    <div className="card-header fw-semibold">IAS 7–style Cash Flow</div>
                    <div className="card-body">
                        <h6>Operating</h6>
                        <div className="d-flex justify-content-between small"><span>Customer collections</span><span>{cashFlow.operating.customer_collections.toLocaleString()}</span></div>
                        <div className="d-flex justify-content-between small"><span>Operating expenses</span><span>({cashFlow.operating.operating_expenses.toLocaleString()})</span></div>
                        <div className="d-flex justify-content-between small"><span>Supplier payments</span><span>({cashFlow.operating.supplier_payments.toLocaleString()})</span></div>
                        <div className="d-flex justify-content-between fw-semibold"><span>Net operating</span><span>{cashFlow.operating.net.toLocaleString()}</span></div>
                        <hr />
                        <h6>Investing</h6>
                        <div className="d-flex justify-content-between small"><span>Fixed asset purchases</span><span>({cashFlow.investing.fixed_asset_purchases.toLocaleString()})</span></div>
                        <div className="d-flex justify-content-between fw-semibold"><span>Net investing</span><span>{cashFlow.investing.net.toLocaleString()}</span></div>
                        <hr />
                        <h6>Financing</h6>
                        <div className="d-flex justify-content-between small"><span>Inflows</span><span>{cashFlow.financing.inflows.toLocaleString()}</span></div>
                        <div className="d-flex justify-content-between small"><span>Outflows</span><span>({cashFlow.financing.outflows.toLocaleString()})</span></div>
                        <div className="d-flex justify-content-between fw-semibold"><span>Net financing</span><span>{cashFlow.financing.net.toLocaleString()}</span></div>
                        <hr />
                        <div className="d-flex justify-content-between fw-bold"><span>Net increase in cash</span><span>{cashFlow.net_increase_in_cash.toLocaleString()}</span></div>
                        <p className="small text-muted mt-2 mb-0">{cashFlow.note}</p>
                    </div>
                </div>
            )}

            {tab === 'gateway' && (
                <div className="row g-3">
                    <div className="col-md-5">
                        <div className="card table-card">
                            <div className="card-header fw-semibold">Create checkout</div>
                            <div className="card-body">
                                <form onSubmit={startCheckout} className="row g-2">
                                    <div className="col-12">
                                        <select className="form-select form-select-sm" value={checkout.gateway} onChange={(e) => setCheckout({ ...checkout, gateway: e.target.value })}>
                                            <option value="stripe">Stripe</option>
                                            <option value="paypal">PayPal</option>
                                            <option value="bkash">bKash</option>
                                            <option value="manual">Manual</option>
                                        </select>
                                    </div>
                                    <div className="col-6"><input type="number" className="form-control form-control-sm" placeholder="Amount" required value={checkout.amount} onChange={(e) => setCheckout({ ...checkout, amount: e.target.value })} /></div>
                                    <div className="col-6"><input className="form-control form-control-sm" value={checkout.currency} onChange={(e) => setCheckout({ ...checkout, currency: e.target.value })} /></div>
                                    <div className="col-12"><input className="form-control form-control-sm" placeholder="Booking ID (optional)" value={checkout.booking_id} onChange={(e) => setCheckout({ ...checkout, booking_id: e.target.value })} /></div>
                                    <div className="col-12"><button className="btn btn-primary btn-sm">Create</button></div>
                                </form>
                                <p className="small text-muted mt-2 mb-0">Stripe uses STRIPE_SECRET_KEY. PayPal/bKash store intent until credentials configured.</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-7">
                        <div className="card table-card">
                            <div className="table-responsive">
                                <table className="table table-sm mb-0">
                                    <thead><tr><th>Gateway</th><th>Amount</th><th>Status</th><th>External</th></tr></thead>
                                    <tbody>
                                        {gateways.map((g) => (
                                            <tr key={g.id}><td>{g.gateway}</td><td>{Number(g.amount).toLocaleString()}</td><td>{g.status}</td><td className="small">{g.external_id}</td></tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {tab === 'audit' && (
                <div className="card table-card">
                    <div className="table-responsive" style={{ maxHeight: 420 }}>
                        <table className="table table-sm mb-0">
                            <thead className="table-light"><tr><th>When</th><th>User</th><th>Action</th><th>Entity</th><th>ID</th></tr></thead>
                            <tbody>
                                {audit.map((a) => (
                                    <tr key={a.id}>
                                        <td className="small">{a.created_at ? new Date(a.created_at).toLocaleString() : ''}</td>
                                        <td>{a.user_id}</td>
                                        <td>{a.action}</td>
                                        <td>{a.entity}</td>
                                        <td>{a.entity_id}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}

            {tab === 'company' && (
                <div className="row g-3">
                    <div className="col-md-5">
                        <div className="card table-card">
                            <div className="card-header fw-semibold">Company profile (single company)</div>
                            <div className="card-body">
                                <form onSubmit={createCompany} className="row g-2">
                                    <div className="col-8"><input className="form-control form-control-sm" placeholder="Name" required value={coForm.name} onChange={(e) => setCoForm({ ...coForm, name: e.target.value })} /></div>
                                    <div className="col-4"><input className="form-control form-control-sm" placeholder="Code" required value={coForm.code} onChange={(e) => setCoForm({ ...coForm, code: e.target.value })} /></div>
                                    <div className="col-12"><input className="form-control form-control-sm" placeholder="Address" value={coForm.address} onChange={(e) => setCoForm({ ...coForm, address: e.target.value })} /></div>
                                    <div className="col-6"><input className="form-control form-control-sm" placeholder="Email" value={coForm.email} onChange={(e) => setCoForm({ ...coForm, email: e.target.value })} /></div>
                                    <div className="col-6"><input className="form-control form-control-sm" placeholder="Phone" value={coForm.phone} onChange={(e) => setCoForm({ ...coForm, phone: e.target.value })} /></div>
                                    <div className="col-12"><button className="btn btn-primary btn-sm">Save</button></div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-7">
                        <div className="card table-card">
                            <div className="table-responsive">
                                <table className="table mb-0">
                                    <thead><tr><th>Code</th><th>Name</th><th>Email</th><th>Active</th></tr></thead>
                                    <tbody>
                                        {companies.map((c) => (
                                            <tr key={c.id}><td>{c.code}</td><td>{c.name}</td><td>{c.email}</td><td>{c.is_active ? 'Yes' : 'No'}</td></tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
